module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0048.jpg?v=e5cb3d16";